import { Scope } from '../../../jira/clients/response-types';

export const defaultPermissionsSupplier: () => Promise<Scope[]> = () => {
	const response = Object.values(Scope);
	return Promise.resolve(response);
};
